import React from 'react';
import {observer} from 'mobx-react';

const NotFoundBoard: React.FC = () => <div>Страница не найдена.</div>;

export default observer(NotFoundBoard);
